import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsRoutePath } from '#/modules/search/events/routing/searchGetEventsRoutePath';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetInternshipsRoutePath } from '#/modules/search/internships/routing/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/jobs/routing/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/orgs/routing/searchGetOrgsRoutePath';
import type { SearchFiltersByName } from '#/modules/search/types/FiltersByName/SearchFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';
import { searchGetVolopsRoutePath } from '#/modules/search/volops/routing/searchGetVolopsRoutePath';

type Args = {
  locale: I18nLocale;
  filtersByName: SearchFiltersByName;
  q?: string;
  radius?: RadiusParam;
  sort?: SearchSortType;
  pageIndex?: number;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | null;
};

export function searchGetRoutePathSwitch({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
  embedSearchWidgetId,
}: Args) {
  switch (filtersByName.type) {
    case 'JOB':
      return searchGetJobsRoutePath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
        embedSearchWidgetId,
      });

    case 'INTERNSHIP':
      return searchGetInternshipsRoutePath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
      });

    case 'VOLOP':
      return searchGetVolopsRoutePath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
        embedSearchWidgetId,
      });

    case 'EVENT':
      return searchGetEventsRoutePath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
      });

    case 'ORG':
      return searchGetOrgsRoutePath({
        locale,
        q,
        radius,
        filtersByName,
        sort,
        pageIndex,
      });
  }
}
